import { CancelTokenSource } from 'axios';
import { PatientCardDataDto, PatientGuarantorDto } from 'ts-types/api.types';
import axios from 'services/http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/patient-guarantors`;

export const getPatientGuarantorsAfterCardDataRead = (
    source: CancelTokenSource,
    patientCardDataDto: Partial<PatientCardDataDto>): Promise<Array<PatientGuarantorDto>> => {
  return axios
      .post(`${apiUri}/card-data-read`, patientCardDataDto, {cancelToken: source.token})
      .then((response) => response.data);
};
